<template>
  <div>
    <div class="row-width-actions-bar is-border-top">
      <div class="columns is-gapless">
        <div class="column is-padding-left-small is-self-centered">
          <div class="is-size-6">
            <input
              v-if="isAdmin && isPromoteur"
              :id="idx + '-choice-name'"
              class="input is-borderless is-small is-fullwidth is-shadowless"
              placeholder="Titre liste"
              type="text"
              v-model="choice.name"
              @change="$store.commit('modifyCurrentSale', { key: `choix_et_tma.choices[${idx}].name`, value: choice.name })"
              :disabled="!canEdit">
            <span
              v-else-if="!(isAdmin && isPromoteur) && !choice.name"
              class="input is-borderless is-small is-fullwidth has-text-grey">Titre liste</span>
            <span
              v-else-if="!(isAdmin && isPromoteur) && choice.name"
              class="input is-borderless is-small is-fullwidth">{{ choice.name }}</span>
          </div>
        </div>
        <div
          v-if="!choice.document && isAdmin && isPromoteur"
          class="column is-narrow is-border-left">
          <label
            class="page-header-btn is-small is-square tooltip is-tooltip-top"
            data-tooltip="Lier un document">
            <input
              class="file-input"
              type="file"
              accept="image/*, .pdf"
              @change="processFile($event)"
              name="resume">
            <span class="is-marginless icon is-size-4">
              <i
                v-if="!uploading"
                class="fal fa-link"></i>
              <i
                v-else
                class="fas fa-spinner fa-spin"></i>
            </span>
          </label>
        </div>
        <template v-else>
          <div
            v-if="seeDoc"
            class="column is-narrow has-background-white is-border-left is-flex is-padding-small">
            <a
              @click="download()"
              class="icon has-text-grey is-self-centered tooltip is-tooltip-top"
              data-tooltip="Télécharger"><i class="fal fa-download"></i></a>
          </div>
          <div
            v-if="isAdmin && isPromoteur"
            class="column is-narrow has-background-white is-border-left is-flex is-padding-small">
            <a
              @click="unlink()"
              class="icon has-text-grey is-self-centered tooltip is-tooltip-top"
              data-tooltip="Supprimer document lié"><i class="fal fa-unlink"></i></a>
          </div>
        </template>
        <div
          v-if="idx > 0 && isAdmin && isPromoteur"
          class="column is-narrow is-border-left">
          <button
            @click="deleteList()"
            class="page-header-btn is-small is-square tooltip is-tooltip-top"
            data-tooltip="Supprimer la liste">
            <span
              class="icon is-size-4"><i class="fal fa-trash-alt"></i></span>
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="!openWysi"
      class="vadDiscussion is-border-top">
      <div
        class="vadDiscussion--bulle is-size-6 is-minH50p vadDiscussion--bulle--has-actions is-cut is-padding-left">
        <div
          class="content"
          v-if="choice.comment"
          v-html="choice.comment"></div>
        <div
          class="content"
          v-else>
          Aucun commentaire
        </div>
        <div class="actionsOnRow actionsOnRow--vertical">
          <div
            v-if="isAdmin && isPromoteur"
            class="">
            <button
              @click="openWysiwyg()"
              class="is-min-height-full">
              <span class="icon is-small"><i class="fal fa-edit"></i></span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="columns is-gapless is-border-top">
      <div class="column">
        <wysiwyg-editor
          :light="true"
          :model="commentaire"
          @change="updateComment"
          class="has-parent-border">
        </wysiwyg-editor>
      </div>
      <div class="actionsOnRow actionsOnRow--vertical">
        <div class="">
          <button
            type="button"
            class="actionsOnRow-btn--hoverIsDanger"
            @click="openWysi = false; commentaire = choice.comment">
            <span class="icon is-small"><i class="fal fa-times"></i></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Upload } from '@/mixins'

export default {
  name: 'ChoixList',
  mixins: [Upload],
  props: {
    source: {
      type: Object,
      required: true
    },
    canEdit: Boolean,
    idx: Number,
    adv: {
      type: Object
    }
  },
  data () {
    return {
      validDocument: null,
      openWysi: null,
      choice: null,
      commentaire: null,
      uploading: false
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isPromoteur', 'plan']),
    /**
      * display doc
      * @returns {boolean}
      */
    seeDoc () {
      if (this.isAdmin && this.isPromoteur) return true
      else if ('document' in this.choice && this.choice.document) {
        if ('display' in this.choice.document && this.choice.document.display) return true
        else return false
      } else {
        return false
      }
    }
  },
  created () {
    if (this.isAdmin && this.isPromoteur) {
      this.openWysiwyg()
    } else {
      this.openWysi = false
    }
    this.choice = this.source
    if (this.choice.comment) {
      this.commentaire = this.choice.comment
    }
    if (this.choice.name === null) {
      this.choice.name = ''
    }
  },
  methods: {
    /**
      * update comment
      */
    updateComment (val) {
      this.commentaire = val
      this.$store.commit('modifyCurrentSale', { key: `choix_et_tma.choices[${this.idx}].comment`, value: this.commentaire })
    },
    /**
      * open wysiwyg
      */
    openWysiwyg () {
      this.openWysi = true
      if (this.plan.adv_enabled && this.adv.promoteur.plan.adv_enabled) {
        this.$nextTick(() => {
          let selection = document.getSelection()
          let range = document.createRange()
          let contenteditable = document.getElementsByClassName('ql-editor')
          contenteditable = contenteditable[this.idx]
          if (contenteditable.lastChild.nodeType === 3) {
            range.setStart(contenteditable.lastChild, contenteditable.lastChild.length)
          } else {
            range.setStart(contenteditable, contenteditable.childNodes.length)
          }
          selection.removeAllRanges()
          selection.addRange(range)
        })
      }
    },
    /**
      * emit delete list
      */
    deleteList () {
      this.$emit('deleteList', this.idx)
    },
    /**
      * process file
      * @param {object} event
      */
    async processFile (event) {
      let file = event.target.files[0]
      this.validDocument = await this.checkAutorizedFile(file)
      if (this.validDocument === false) {
        setTimeout(() => {
          this.validDocument = null
        }, 2000)
        return
      }
      let files = new FormData()
      files.append('file[]', file, file.name)
      this.uploading = true
      let document = null
      try {
        await this.setFusToken()
        let res = await this.$fus.post({ data: files })
        document = res.data[0]
        document.fus_id = document.id
        document.filename = file.name
      } catch (e) {
        console.log(e)
      }
      if (document) {
        this.$set(this.choice, 'document', document)
        this.$store.commit('modifyCurrentSale', { key: `choix_et_tma.choices[${this.idx}].document`, value: this.choice.document })
        this.uploading = false
      }
    },
    /**
      * download choice document
      */
    download () {
      let link = document.createElement('a')
      link.href = this.choice.document.path
      link.target = '_blank'
      link.click()
    },
    /**
      * unlink document
      */
    unlink () {
      this.$set(this.choice, 'document', null)
      this.$store.commit('modifyCurrentSale', { key: `choix_et_tma.choices[${this.idx}].document`, value: this.choice.document })
    }
  }
}
</script>
